export default __webpack_public_path__ + "static/media/memory.7d894109.png";